import type { IProviderConfig } from '../types/template';

import { ProviderSource } from '../types/template';
import { THUMBNAIL } from './thumbnail';

export const PROVIDER_CONFIG: Record<ProviderSource, IProviderConfig> = {
  [ProviderSource.SHOPIFY_GEMX]: {
    label: 'GemX',
    prefix: 'gemx-',
    isMapping: true,
    thumbnail: THUMBNAIL.THUMB_GEMX,
    logo: { icon: 'ab-testing' },
  },
  [ProviderSource.SHOPIFY_PAGE_FLY]: {
    label: 'PageFly',
    prefix: 'pf-',
    isMapping: true,
    pathName: 'apps/pagefly/pages',
    thumbnail: THUMBNAIL.THUMB_GEMX,
    logo: { icon: 'ab-testing' },
  },
  [ProviderSource.SHOPIFY_FOXIFY]: {
    label: 'Foxify',
    prefix: 'foxify-',
    isMapping: true,
    pathName: 'apps/foxify-builder/pages',
    thumbnail: THUMBNAIL.THUMB_GEMX,
    logo: { icon: 'ab-testing' },
  },
  [ProviderSource.SHOPIFY_ECOMPOSER]: {
    label: 'EComposer',
    prefix: 'ecom-',
    thumbnail: THUMBNAIL.THUMB_GEMX,
    isMapping: true,
    pathName: 'apps/ecomposer/pages',
    logo: { icon: 'ab-testing' },
  },
  [ProviderSource.SHOPIFY]: {
    label: 'Shopify',
    thumbnail: THUMBNAIL.THUMB_GEMX,
    logo: { icon: 'ab-testing' },
  },
  [ProviderSource.SHOPIFY_ORIGIN]: {
    label: 'Shopify',
    thumbnail: THUMBNAIL.THUMB_GEMX,
    logo: { icon: 'ab-testing' },
  },
  [ProviderSource.GEMPAGESV6]: {
    label: 'GemPages',
    thumbnail: THUMBNAIL.THUMB_GEMX,
    logo: { icon: 'ab-testing' },
  },
  [ProviderSource.GEMPAGESV7]: {
    label: 'GemPages',
    thumbnail: THUMBNAIL.THUMB_GEMX,
    logo: { icon: 'ab-testing' },
  },
};
